<template lang="pug">
  main.not-found#main
    .hero
      .hero-text-wrapper
        h1 Not Found
        p Sorry, we can't find the page you're looking for.
    section
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="stylus">
.not-found
  section
    height 10vh
</style>
